import {
  UniFiCategoryId,
  UniFiChildCategorySlug,
} from "@ubnt/store.core/lib/constants/proStoreCategories/mapping/unifi";
import { SiteId } from "@ubnt/store.core/lib/contexts/MenuContext/mapping";
import image from "../../assets/wifi/wall/u7-pro-wall.png";
import type { Product } from "../../types";
import { wifiWall } from "../product-list-groups/wifi-wall";
import {
  connectedDevices,
  dimensions,
  integratedSwitch,
  radio6Ghz,
  uplink,
  wifiCoverage,
  wifiMounting,
  wifiTechnology,
} from "../properties";
import { customization } from "../properties/customization";

export const u7proWall: Product = {
  id: "u7proWall",
  productTitle: "U7 Pro Wall",
  techspecsPath: [
    SiteId.TechSpecs,
    `/unifi/${UniFiCategoryId.WiFi}/u7-pro-wall`,
  ],
  storePathParts: {
    productSlug: "u7-pro-wall",
    category: UniFiChildCategorySlug.WiFiWall,
  },
  isNew: true,
  sku: "U7-Pro-Wall",
  description: "u7proWall.description.1",
  image: { src: image, width: 200, height: 160 },
  productListGroup: wifiWall,
  propertyValues: [
    {
      propertyId: wifiTechnology.id,
      value: {
        type: "translation",
        value: "u7proWall.wifiTechnology",
      },
    },
    {
      propertyId: dimensions.id,
      value: {
        type: "translation",
        value: "u7proWall.dimensions",
      },
    },
    {
      propertyId: radio6Ghz.id,
      value: { type: "boolean", value: true },
    },
    {
      propertyId: wifiCoverage.id,
      value: { type: "string", value: "140 m² (1,500 ft²)" },
    },
    {
      propertyId: connectedDevices.id,
      value: { type: "string", value: "300+" },
    },
    {
      propertyId: integratedSwitch.id,
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "powerMethodPoe",
      value: { type: "string", value: "PoE+" },
    },
    {
      propertyId: uplink.id,
      value: { type: "string", value: "2.5 GbE" },
    },
    {
      propertyId: wifiMounting.id,
      value: {
        type: "translation",
        value: "u7proWall.mounting",
        asterisk: 1,
      },
    },
    {
      propertyId: customization.id,
      value: {
        type: "translation",
        value: "u7proWall.customization",
      },
    },
    // MUST HAVE FOR OVERVIEW SECTION
    {
      propertyId: "radios",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "extendedRangeMode6Ghz",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "rfFilteringTechnology",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "antennaType",
      value: {
        type: "translation",
        value: "antennaType.omnidirectional",
      },
    },
    {
      propertyId: "weatherproofing",
      value: { type: "boolean", value: false },
    },
    {
      propertyId: "redundantRj45Port",
      value: { type: "boolean", value: false },
    },
  ],
  notes: ["u7proWall.notes"],
};
